/**
 * Singleton stats-gl — initialisé et piloté depuis ContainerManager,
 * affiché conditionnellement via REACT_APP_SHOW_PERFORMANCE_STATS.
 */

let statsInstance = null

export const isStatsEnabled = () =>
    process.env.REACT_APP_SHOW_PERFORMANCE_STATS === 'true'

export const initStats = async (renderer) => {
    if (!isStatsEnabled()) return
    const { default: Stats } = await import('stats-gl')
    statsInstance = new Stats({ trackGPU: true, trackFPS: true, horizontal: true })

    // Three.js 0.127 n'a pas isWebGLRenderer, stats-gl ne le détecte pas automatiquement.
    // On passe directement le contexte WebGL2 pour contourner.
    const gl = renderer.getContext()
    statsInstance.init(gl)

    document.body.appendChild(statsInstance.dom)
}

export const statsBegin = () => statsInstance?.begin()
export const statsEnd   = () => statsInstance?.end()
export const statsUpdate = () => statsInstance?.update()

export const disposeStats = () => {
    if (!statsInstance) return
    statsInstance.dispose?.()
    if (statsInstance.dom?.parentNode) statsInstance.dom.parentNode.removeChild(statsInstance.dom)
    statsInstance = null
}
